import ReactDOM from 'react-dom/client';

import App from './App';
import './styles/index.css';
import 'antd/dist/reset.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
